export enum CopilotTeachingPopoverAnchorID {
    MetaOSCopilotButton = '0',
    CommandCenterCopilotButton = '1',
}
